export class AccountRegistrationModel {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  languageId: number;
  currencyId: number;
  companyName: string;
  companyPhone: string;
  companyEmail: string;
  webSite: string;
  estimateYearlySales: number;
  regionId: number;
  address1: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  whiteLabelSite: boolean;
  storeSite: boolean;
  apiAccess: boolean;
  notes: string;
  status: string;
  createdOn: Date;

  constructor(id: string,
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string,
    languageId: number,
    currencyId: number,
    companyName: string,
    companyPhone: string,
    companyEmail: string,
    webSite: string,
    estimateYearlySales: number,
    regionId: number,
    address1: string,
    address2: string,
    city: string,
    state: string,
    country: string,
    whiteLabelSite: boolean,
    storeSite: boolean,
    apiAccess: boolean,
    notes: string,
    status: string,
    createdOn: Date) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.languageId = languageId;
    this.currencyId = currencyId;
    this.companyName = companyName;
    this.companyPhone = companyPhone;
    this.companyEmail = companyEmail;
    this.webSite = webSite;
    this.estimateYearlySales = estimateYearlySales;
    this.regionId = regionId;
    this.address1 = address1;
    this.address2 = address2;
    this.city = city;
    this.state = state;
    this.country = country;
    this.whiteLabelSite = whiteLabelSite;
    this.notes = notes;
    this.storeSite = storeSite;
    this.apiAccess = apiAccess;
    this.status = status;
    this.createdOn = createdOn;
  }

  public static createNew(): AccountRegistrationModel {
    return new AccountRegistrationModel('', '', '', '', '', 1, 1, '', '', '', '', null,
      null, '', '', '', '', '', false, false, false, '', '', new Date());
  }

  public static parse(data: any): AccountRegistrationModel {
    return new AccountRegistrationModel(
      data['id'],
      data['firstName'],
      data['lastName'],
      data['email'],
      data['phoneNumber'],
      data['languageId'],
      data['currencyId'],
      data['companyName'],
      data['companyPhone'],
      data['companyEmail'],
      data['webSite'],
      data['estimateYearlySales'],
      data['regionId'],
      data['address1'],
      data['address2'],
      data['city'],
      data['state'],
      data['country'],
      data['whiteLabelSite'],
      data['storeSite'],
      data['apiAccess'],
      data['notes'],
      data['status'],
      data['createdOn']);
  }
}
